import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Section, FeedbackQuestions } from '../s'
import { H1 as Title } from 'components/typography/heading'
import Paragraph from 'components/typography/paragraph'

const AltinnAbout = ({ name, upgradable }) => (
    <>
        <Section>
            <Title>{name}</Title>
            <Paragraph>
                <FormattedMessage
                    id="integration_altinn_preamble_about"
                    defaultMessage="Create sick leave automatically in Huma when it’s added in Altinn." />
            </Paragraph>
        </Section>
        <FeedbackQuestions mode={upgradable ? 'support' : 'sales'} />
    </>
)

export default AltinnAbout